import { FiChevronLeft, FiChevronRight, FiCalendar } from 'react-icons/fi';
import { useCalendarStore } from '@/store/calendarStore';
import { formatDate, getMonthName, getWeekNumber, getDaysInWeek } from '@/utils/dateUtils';
import { getDualDate, formatHebrewDate } from '@/utils/hebrewCalendar';
import FilterPanel from './FilterPanel';

/**
 * Componente de encabezado del calendario
 */
export default function CalendarHeader() {
  const { 
    currentDate, 
    view, 
    setView,
    goToToday,
    goToPreviousDay,
    goToNextDay,
    goToPreviousWeek,
    goToNextWeek,
    goToPreviousMonth,
    goToNextMonth,
    goToPreviousYear,
    goToNextYear,
    settings
  } = useCalendarStore();

  const dualDate = getDualDate(currentDate, settings.hebrewDayStart);

  const handlePrevious = () => {
    if (view === 'day') goToPreviousDay();
    else if (view === 'week') goToPreviousWeek();
    else if (view === 'month') goToPreviousMonth();
    else if (view === 'year') goToPreviousYear();
  };

  const handleNext = () => {
    if (view === 'day') goToNextDay();
    else if (view === 'week') goToNextWeek();
    else if (view === 'month') goToNextMonth();
    else if (view === 'year') goToNextYear();
  };

  const getTitle = () => {
    if (view === 'day') {
      return formatDate(currentDate, 'dd MMMM yyyy');
    } else if (view === 'week') {
      const weekDays = getDaysInWeek(currentDate);
      return `Semana ${getWeekNumber(currentDate)} - ${formatDate(weekDays[0], 'd MMM')} al ${formatDate(weekDays[6], 'd MMM yyyy')}`;
    } else if (view === 'month') {
      return `${getMonthName(currentDate)} ${currentDate.getFullYear()}`;
    } else {
      return currentDate.getFullYear().toString();
    }
  };

  return (
    <div className="bg-white shadow-md rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <button
            onClick={handlePrevious}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            aria-label="Anterior"
          >
            <FiChevronLeft className="w-6 h-6" />
          </button>
          <button
            onClick={handleNext}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            aria-label="Siguiente"
          >
            <FiChevronRight className="w-6 h-6" />
          </button>
          <button
            onClick={goToToday}
            className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-blue-600 transition-colors flex items-center gap-2"
          >
            <FiCalendar className="w-4 h-4" />
            Hoy
          </button>
        </div>

        <div className="flex items-center gap-2">
          <FilterPanel />
          
          <div className="flex gap-2">
            <button
              onClick={() => setView('day')}
              className={`px-4 py-2 rounded-lg transition-colors ${
                view === 'day' 
                  ? 'bg-primary text-white' 
                  : 'bg-gray-100 hover:bg-gray-200'
              }`}
            >
              Día
            </button>
            <button
              onClick={() => setView('week')}
              className={`px-4 py-2 rounded-lg transition-colors ${
                view === 'week' 
                  ? 'bg-primary text-white' 
                  : 'bg-gray-100 hover:bg-gray-200'
              }`}
            >
              Semana
            </button>
            <button
              onClick={() => setView('month')}
              className={`px-4 py-2 rounded-lg transition-colors ${
                view === 'month' 
                  ? 'bg-primary text-white' 
                  : 'bg-gray-100 hover:bg-gray-200'
              }`}
            >
              Mes
            </button>
            <button
              onClick={() => setView('year')}
              className={`px-4 py-2 rounded-lg transition-colors ${
                view === 'year' 
                  ? 'bg-primary text-white' 
                  : 'bg-gray-100 hover:bg-gray-200'
              }`}
            >
              Año
            </button>
          </div>
        </div>
      </div>

      <div className="text-center">
        <h2 className="text-2xl font-bold text-gray-800 mb-2">
          {getTitle()}
        </h2>
        {settings.showDualCalendar && (
          <p className="text-sm text-gray-600">
            {formatHebrewDate(dualDate.hebrew)}
            {dualDate.isHebrewDay && ' (Día Hebreo)'}
          </p>
        )}
      </div>
    </div>
  );
}



